import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue")),
  "isolated-page": defineAsyncComponent(() => import("/app/layouts/isolated-page.vue")),
  meetings: defineAsyncComponent(() => import("/app/layouts/meetings.vue")),
  recordings: defineAsyncComponent(() => import("/app/layouts/recordings.vue"))
}